import rsvpCreateTemplate from './views/pages/rsvps/create.tpl.html';
import rsvpMasterListTemplate from './views/rsvps-masterlist.tpl.html';
import rsvpMasterChangelogTemplate from './views/rsvps-master-changelog.tpl.html';
// Controllers
import GuestlistTemplatesPageController from './controllers/pages/guestlists/messages/templates-controller';
import GuestlistMessageSettingsPageController from './controllers/pages/guestlists/messages/settings-controller';
import GuestlistSentMessagesPageController from './controllers/pages/guestlists/messages/sent-controller';
import GuestlistOverviewMessagesPageController from './controllers/pages/guestlists/messages/overview-controller';
import GuestlistProtectedFilesPageController from './controllers/pages/guestlists/protected-files-controller';
import GuestlistRsvpsListPageController from './controllers/pages/rsvps/list-controller';
import GuestlistRsvpsChangelogPageController from './controllers/pages/rsvps/changelog-controller';
import GuestlistSettingsPageController from './controllers/pages/guestlists/settings-controller';
import GuestlistLandingpageSettingsPageController from './controllers/pages/guestlists/lp-settings-controller';
import GuestlistsListPageController from './controllers/pages/guestlists/list-controller';
import GuestlistSeatplanPageController from './controllers/pages/guestlists/seatplan-controller';
import GuestlistLimitsPageController from './controllers/pages/guestlists/limits-controller';
import GuestlistReleaseSettingsPageController from './controllers/pages/guestlists/release-settings-controller';
import GuestlistShortTermSettingsController from './controllers/pages/guestlists/short-term-settings-controller';
import GuestlistRsvpsImportPageController from './controllers/pages/rsvps/import-controller';
import GuestlistRsvpsDuplicatesPageController from './controllers/pages/rsvps/duplicates-controller';
import GuestlistRsvpsCreatePageController from './controllers/pages/rsvps/rsvps-create-controller';
import GuestlistPublicSeatsPageController from './controllers/pages/guestlists/public-seats-controller';
import GuestlistPdfTicketPageController from './controllers/pages/guestlists/tickets/pdf-ticket-controller';
import GuestlistTicketSettingsPageController from './controllers/pages/guestlists/tickets/ticket-settings-controller';
import GuestlistWalletTicketPageController from './controllers/pages/guestlists/tickets/wallet-ticket-controller';
import GuestlistOptionLinksPageController from './controllers/pages/guestlists/option-links-controller';
import GuestlistOverviewPageController from './controllers/pages/guestlists/overview-controller';

import RsvpDetailsOverviewPageController from './controllers/pages/rsvps/details/overview-controller';
import RsvpDetailsMessagesPageController from './controllers/pages/rsvps/details/messages-controller';
import RsvpDetailsGuestsPageController from './controllers/pages/rsvps/details/guests-controller';
import RsvpDetailsChangelogPageController from './controllers/pages/rsvps/details/changelog-controller';
import RsvpDetailsOptionLinksPageController from './controllers/pages/rsvps/details/option-links-controller';
import RsvpDetailsEditPageController from './controllers/pages/rsvps/details/edit-controller';
import RsvpDetailsCheckinsPageController from './controllers/pages/rsvps/details/checkins-controller';

// Templates
import guestlistTemplatesTemplateUrl from './views/pages/guestlists/messages/templates.tpl.html';
import guestlistMessageSettingsTemplateUrl from './views/pages/guestlists/messages/settings.tpl.html';
import guestlistSentMessagesTemplateUrl from './views/pages/guestlists/messages/sent.tpl.html';
import guestlistOverviewMessagesTemplateUrl from './views/pages/guestlists/messages/overview.tpl.html';
import guestlistsListTemplateUrl from './views/pages/guestlists/list.tpl.html';
import guestlistLimitsTemplateUrl from './views/pages/guestlists/limits.tpl.html';
import guestlistProtectedFilesTemplateUrl from './views/pages/guestlists/protected-files.tpl.html';
import guestlistSettingsTemplateUrl from './views/pages/guestlists/settings.tpl.html';
import guestlistLpSettingsTemplateUrl from './views/pages/guestlists/lp-settings.tpl.html';
import guestlistSeatsTemplateUrl from './views/pages/guestlists/seatplan.tpl.html';
import guestlistOverviewTemplateUrl from './views/pages/guestlists/overview.tpl.html';
import guestlistReleaseSettingsTemplateUrl from './views/pages/guestlists/release-settings.tpl.html';
import guestlistShortTermSettingsTemplateUrl from './views/pages/guestlists/short-term-settings.tpl.html';
import guestlistPublicSeatsTemplateUrl from './views/pages/guestlists/public-seats.tpl.html';
import guestlistPdfTicketTemplateUrl from './views/pages/guestlists/tickets/pdf-ticket.tpl.html';
import guestlistTicketSettingsTemplateUrl from './views/pages/guestlists/tickets/ticket-settings.tpl.html';
import guestlistWalletTicketTemplateUrl from './views/pages/guestlists/tickets/wallet-ticket.tpl.html';
import guestlistOptionLinksTemplateUrl from './views/pages/guestlists/option-links.tpl.html';
import guestlistCenterStageTemplateUrl from './views/pages/guestlists/centerstage.tpl.html';

import rsvpListTemplateUrl from './views/pages/rsvps/list.tpl.html';
import rsvpImportTemplateUrl from './views/pages/rsvps/import.tpl.html';
import rsvpDetailsOverviewTemplateUrl from './views/pages/rsvps/details/overview.tpl.html';
import rsvpDetailsMessagesTemplateUrl from './views/pages/rsvps/details/messages.tpl.html';
import rsvpDetailsGuestsTemplateUrl from './views/pages/rsvps/details/guests.tpl.html';
import rsvpDetailsChangelogTemplateUrl from './views/pages/rsvps/details/changelog.tpl.html';
import rsvpDetailsOptionLinksTemplateUrl from './views/pages/rsvps/details/option-links.tpl.html';
import rsvpDetailsEditTemplateUrl from './views/pages/rsvps/details/edit.tpl.html';
import rsvpDetailsCheckinsTemplateUrl from './views/pages/rsvps/details/checkins.tpl.html';
import rsvpChangelogTemplateUrl from './views/pages/rsvps/changelog.tpl.html';
import rsvpDuplicatesTemplateUrl from './views/pages/rsvps/duplicates.tpl.html';
import GuestlistCenterStagePageController from './controllers/pages/guestlists/centerstage-controller';

angular
    .module('festzelt-os.guestlists')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.guestlists', {
            abstract: true,
            url: '/guestlists',
            template: '<ui-view />',
            data: {
                showBackBtn: true,
                pageTitle: 'Guestlists',
            }
        })
        .state('app.guestlists.index', {
            url: '',
            data: {
                rights: 'guestlists::list'
            },
            templateUrl: guestlistsListTemplateUrl,
            controller: GuestlistsListPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.masterlist', {
            url: '/master',
            params: {
                rows: undefined,
                store: undefined
            },
            data: {
                rights: 'rsvps::masterlist',
                bodyClass: 'wide'
            },
            templateUrl: rsvpMasterListTemplate,
            controller: 'RsvpsMasterListCtrl',
            controllerAs: 'vm'
        })
        .state('app.guestlists.master-changelog', {
            url: '/master/changelog',
            params: {
                rows: undefined,
                store: undefined
            },
            data: {
                rights: 'rsvps::changelog',
                bodyClass: 'wide'
            },
            templateUrl: rsvpMasterChangelogTemplate
        })
        .state('app.guestlists.rsvps', {
            url: '/:gid',
            sticky: true,
            abstract: true,
            data: {
                pageTitle: 'Bookings'
            },
            params: {
                guestlist: {
                    type: 'any',
                    inherit: true,
                    value: null
                },
                gid: {
                    inherit: true,
                    type: 'int'
                }
            },
            template: '<ui-view />'
        })
        .state('app.guestlists.rsvps.overview', {
            url: '/overview',
            data: {
                bodyClass: 'wide',
                rights: 'guestlists::view'
            },
            templateUrl: guestlistOverviewTemplateUrl,
            controller: GuestlistOverviewPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.index', {
            url: '/rsvps',
            data: {
                bodyClass: 'wide',
                rights: 'rsvps::list'
            },
            templateUrl: rsvpListTemplateUrl,
            controller: GuestlistRsvpsListPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.changelog', {
            url: '/changelog',
            data: {
                bodyClass: 'wide',
                rights: 'rsvps::changelog'
            },
            templateUrl: rsvpChangelogTemplateUrl,
            controller: GuestlistRsvpsChangelogPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.messages', {
            url: '/messages',
            sticky: true,
            abstract: true,
            template: '<ui-view />'
        })
        .state('app.guestlists.rsvps.messages.templates', {
            url: '/templates',
            data: {
                bodyClass: 'wide',
                rights: 'guestlists::list-templates'
            },
            templateUrl: guestlistTemplatesTemplateUrl,
            controller: GuestlistTemplatesPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.messages.overview', {
            url: '/overview',
            data: {
                bodyClass: 'wide',
                rights: 'guestlists::list-templates'
            },
            templateUrl: guestlistOverviewMessagesTemplateUrl,
            controller: GuestlistOverviewMessagesPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.messages.settings', {
            url: '/settings',
            data: {
                bodyClass: 'wide',
                rights: 'guestlists::edit'
            },
            templateUrl: guestlistMessageSettingsTemplateUrl,
            controller: GuestlistMessageSettingsPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.messages.sent', {
            url: '/sent',
            data: {
                bodyClass: 'wide',
                rights: 'messages::list'
            },
            templateUrl: guestlistSentMessagesTemplateUrl,
            controller: GuestlistSentMessagesPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.tickets', {
            url: '/tickets',
            sticky: true,
            abstract: true,
            template: '<ui-view />'
        })
        .state('app.guestlists.rsvps.tickets.settings', {
            url: '/settings',
            data: {
                bodyClass: 'wide',
                rights: 'guestlists::edit'
            },
            templateUrl: guestlistTicketSettingsTemplateUrl,
            controller: GuestlistTicketSettingsPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.tickets.pdf-ticket', {
            url: '/pdf',
            data: {
                bodyClass: 'wide',
                rights: 'tickets::templates-view'
            },
            templateUrl: guestlistPdfTicketTemplateUrl,
            controller: GuestlistPdfTicketPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.tickets.wallet-ticket', {
            url: '/wallet',
            data: {
                bodyClass: 'wide',
                rights: 'passbooks::view'
            },
            templateUrl: guestlistWalletTicketTemplateUrl,
            controller: GuestlistWalletTicketPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.option-links', {
            url: '/option-links',
            data: {
                bodyClass: 'wide',
                rights: 'bookable_objects::option_link_list'
            },
            templateUrl: guestlistOptionLinksTemplateUrl,
            controller: GuestlistOptionLinksPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.center-stage', {
            url: '/center-stage',
            data: {
                bodyClass: 'wide',
                fullWidth: true
                // rights: 'guestlists::center_stage'
            },
            templateUrl: guestlistCenterStageTemplateUrl,
            controller: GuestlistCenterStagePageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.protected-files', {
            url: '/protected-files',
            data: {
                bodyClass: 'wide',
                rights: 'guestlists::protected-files'
            },
            templateUrl: guestlistProtectedFilesTemplateUrl,
            controller: GuestlistProtectedFilesPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.create', {
            sticky: true,
            url: '/rsvps/create',
            data: {
                rights: 'rsvps::create'
            },
            params: {
                contacts: undefined,
                store: undefined,
                backParams: ['$stateParams', ($stateParams) => ({gid: $stateParams.gid, store: $stateParams.store})]
            },
            templateUrl: rsvpCreateTemplate,
            controller: GuestlistRsvpsCreatePageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.details', {
            url: '/rsvps/{id}',
            sticky: true,
            abstract: true,
            params: {
                rsvp: {
                    type: 'any',
                    inherit: true,
                    value: null
                },
                id: {
                    inherit: true,
                    type: 'int'
                }
            },
            template: '<ui-view />'
        })
        .state('app.guestlists.rsvps.details.overview', {
            url: '',
            data: {
                rights: 'rsvps::view',
                track: false
            },
            templateUrl: rsvpDetailsOverviewTemplateUrl,
            controller: RsvpDetailsOverviewPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.details.messages', {
            url: '/messages',
            data: {
                rights: 'rsvps::messages'
            },
            templateUrl: rsvpDetailsMessagesTemplateUrl,
            controller: RsvpDetailsMessagesPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.details.checkins', {
            url: '/checkins',
            data: {
                rights: 'rsvps::checkins'
            },
            templateUrl: rsvpDetailsCheckinsTemplateUrl,
            controller: RsvpDetailsCheckinsPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.details.guests', {
            url: '/guests',
            data: {
                rights: 'rsvps::list'
            },
            templateUrl: rsvpDetailsGuestsTemplateUrl,
            controller: RsvpDetailsGuestsPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.details.changelog', {
            url: '/changelog',
            data: {
                rights: 'rsvps::list'
            },
            templateUrl: rsvpDetailsChangelogTemplateUrl,
            controller: RsvpDetailsChangelogPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.details.option-links', {
            url: '/option-links',
            data: {
                rights: 'rsvps::list'
            },
            templateUrl: rsvpDetailsOptionLinksTemplateUrl,
            controller: RsvpDetailsOptionLinksPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.details.edit', {
            url: '/edit',
            data: {
                rights: 'rsvps::edit'
            },
            params: {
                store: undefined,
                back: 'app.guestlists.rsvps.details.overview',
                backParams: ['$stateParams', ($stateParams) => ({
                    gid: $stateParams.gid,
                    guestlist: $stateParams.guestlist,
                    id: $stateParams.id,
                    store: $stateParams.store
                })]
            },
            templateUrl: rsvpDetailsEditTemplateUrl,
            controller: RsvpDetailsEditPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.seats', {
            url: '/seats/:rsvpId',
            data: {
                bodyClass: 'wide',
                rights: 'guestlists::seats'
            },
            params: {
                rsvpId: {
                    type: 'int',
                    value: null
                },
                guestlists: {
                    type: 'any',
                    dynamic: true,
                    inherit: true,
                    value: []
                },
                preSelectGroup: {
                    type: 'int',
                    value: 0
                }
            },
            templateUrl: guestlistSeatsTemplateUrl,
            controller: GuestlistSeatplanPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.public_seats', {
            url: '/seats/public',
            params: {
                rows: undefined,
                store: undefined,
                back: 'app.guestlists.seats'
            },
            data: {
                bodyClass: 'wide',
                rights: 'guestlists::public-seats'
            },
            templateUrl: guestlistPublicSeatsTemplateUrl,
            controller: GuestlistPublicSeatsPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.limits', {
            url: '/limits',
            data: {
                rights: 'guestlists::view-limits'
            },
            templateUrl: guestlistLimitsTemplateUrl,
            controller: GuestlistLimitsPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.edit-settings', {
            url: '/edit',
            params: {
                guestlist: undefined,
                back: 'app.guestlists.rsvps.index',
                editorView: 'general',
                editorSubview: 'general'
            },
            sticky: true,
            data: {
                rights: 'guestlists::edit'
            },
            templateUrl: guestlistSettingsTemplateUrl,
            controller: GuestlistSettingsPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.edit-landingpage-settings', {
            url: '/landingpage-edit',
            params: {
                guestlist: undefined,
                back: 'app.guestlists.rsvps.index',
                editorView: 'general',
                editorSubview: 'url'
            },
            sticky: true,
            data: {
                rights: 'guestlists::edit'
            },
            templateUrl: guestlistLpSettingsTemplateUrl,
            controller: GuestlistLandingpageSettingsPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.release-settings', {
            url: '/release-settings',
            data: {
                rights: 'guestlists::edit'
            },
            templateUrl: guestlistReleaseSettingsTemplateUrl,
            controller: GuestlistReleaseSettingsPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.short-term-settings', {
            url: '/short-term-settings',
            data: {
                rights: 'guestlists::edit'
            },
            templateUrl: guestlistShortTermSettingsTemplateUrl,
            controller: GuestlistShortTermSettingsController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.import', {
            url: '/rsvps/import',
            data: {
                back: 'app.guestlists.rsvps.index',
                rights: 'rsvps::import'
            },
            templateUrl: rsvpImportTemplateUrl,
            controller: GuestlistRsvpsImportPageController,
            controllerAs: 'vm'
        })
        .state('app.guestlists.rsvps.duplicates', {
            sticky: true,
            url: '/duplicates',
            data: {
                bodyClass: 'wide',
                rights: 'rsvps::duplicates'
            },
            params: {
                back: 'app.guestlists.rsvps.index',
                store: undefined
            },
            templateUrl: rsvpDuplicatesTemplateUrl,
            controller: GuestlistRsvpsDuplicatesPageController,
            controllerAs: 'vm'
        });
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/guestlists-routes.js